import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Flex, Text } from "@mantine/core";
import {
  PasswordInputControlled,
  PasswordRequirements,
} from "../../../../components";
import { ValidationChangePassword } from "./schema-validation";
import {
  IResetPassword,
  resetPassword,
} from "../../../../hooks/useAuthService";
import { useTranslation } from "react-i18next";

interface IPropsChangePassord {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  emailHash: string;
  userIp: string;
  secretPhrase: string;
}

const ChangePassword: React.FC<IPropsChangePassord> = ({
  setOpenModal,
  emailHash,
  userIp,
  secretPhrase,
}) => {
  const { t } = useTranslation();
  const [erro, setErro] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const methods = useForm<IResetPassword>({
    mode: "all",
    resolver: yupResolver(ValidationChangePassword),
    defaultValues: {
      user_email_hash: emailHash,
      secret_phrase: secretPhrase,
      new_password: "",
      new_password_confirmation: "",
      client_ip: userIp,
    },
  });

  const {
    handleSubmit,
    watch,
    formState: { isDirty, isValid },
  } = methods;

  const onSubmit = async (data: IResetPassword) => {
    setIsLoading(true);
    setErro(null);
    const { new_password_confirmation, ...restData } = data;
    try {
      await resetPassword(restData);
      setOpenModal(true);
    } catch (error: any) {
      const erro = error.response.data;
      if (erro.statusCode === 403) {
        setErro(
          t("autenticacao.acessar_conta.forget_password.step_4.erro_403")
        );
      } else {
        setErro(t("autenticacao.acessar_conta.forget_password.step_4.erro"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex gap={24} mb={24} direction={{ base: "column", md: "row" }}>
          <PasswordInputControlled
            name="new_password"
            label={t("global.input.password.label")}
            placeholder={t("global.input.password.placeholder")}
            w="100%"
          />
          <PasswordInputControlled
            name="new_password_confirmation"
            label={t("global.input.password_confirmation.label")}
            placeholder={t("global.input.password_confirmation.placeholder")}
            w="100%"
          />
        </Flex>
        <PasswordRequirements
          passwordOne={watch("new_password")}
          passwordTwo={watch("new_password_confirmation")}
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="primary"
          fullWidth
          mt={26}
          disabled={!isDirty || !isValid}
          loading={isLoading}
        >
          {t("autenticacao.acessar_conta.forget_password.step_4.button")}
        </Button>
        {erro && <Text color="red">{erro}</Text>}
      </form>
    </FormProvider>
  );
};

export default ChangePassword;
